// extracted by mini-css-extract-plugin
export default {"odometer":"kilometer_odometer__zJLLB","mileage":"kilometer_mileage__XxRMr","units":"kilometer_units__aS8L2"};